import $ from "jquery";
import EventsHelper from "../../../_helpers/events";
import { translationHelperObj } from "../../../_helpers/translationHelper";

export default class MatchList {
  $MatchList = {};
  statusClasses = {
    0: "vbw-mu-scheduled",
    1: "vbw-mu-live",
    2: "vbw-mu-finished",
  };

  matchStatus = {
    DEFAULT: -1,
    SCHEDULED: 0,
    LIVE: 1,
    FINISHED: 2,
  };

  constructor() {
    let _this = this;
    _this.init();

    EventsHelper.OnAjaxModuleLoaded(function () {
      _this.init();
    });

    EventsHelper.On("MatchListDataUpdate", function (data) {
      if (data.detail) {
        for (const match of data.detail) {
          _this.updateScores(match);
          _this.updateSets(match);
          _this.updateStatus(match);
          if (_this.isMatchGoneLive(match.no)) {
            matchDataCollector.loadChannels();
          }
        }
      }
    });
  }

  updateScores(matchData) {
    let _this = this;

    let pointsA =
      matchData.status != _this.matchStatus.FINISHED
        ? matchData.currentSetTeamAPoints
        : matchData.matchPointsA;
    let pointsB =
      matchData.status != _this.matchStatus.FINISHED
        ? matchData.currentSetTeamBPoints
        : matchData.matchPointsB;
    let $match = _this.$MatchList.filter(
      '[matchid="match-' + matchData.no + '"]',
    );

    if ($match.length == 0) {
      return;
    }

    $match.find(".vbw-mu__score--home").text(pointsA);
    $match.find(".vbw-mu__score--away").text(pointsB);

    $match.find(".vbw-mu__score--away").removeClass("winner");
    $match.find(".vbw-mu__score--home").removeClass("winner");

    if (pointsA > pointsB) {
      $match.find(".vbw-mu__score--home").addClass("winner");
    } else if (pointsA < pointsB) {
      $match.find(".vbw-mu__score--away").addClass("winner");
    }
  }

  updateSets(matchData) {
    let _this = this;

    let $match = _this.$MatchList.filter(
      '[matchid="match-' + matchData.no + '"]',
    );
    let currentSet = matchData.currentSetNo;
    let $setsList = $match.find(".vbw-mu__sets--result");

    $setsList.each(function () {
      let setItem = $(this);
      let setNo = setItem.data("set-no");

      let setData = matchData.sets[setNo];

      if (currentSet <= setNo || setData.no === 0) {
        setItem.addClass("hidden");
      } else {
        setItem.removeClass("hidden");
      }

      if (setData) {
        setItem.find(".vbw-mu__pointA").text(setData.pointsTeamA);
        setItem.find(".vbw-mu__pointB").text(setData.pointsTeamB);

        setItem.find(".vbw-mu__pointB").removeClass("winner");
        setItem.find(".vbw-mu__pointA").removeClass("winner");

        if (setData.pointsTeamA > setData.pointsTeamB) {
          setItem.find(".vbw-mu__pointA").addClass("winner");
        } else if (setData.pointsTeamA < setData.pointsTeamB) {
          setItem.find(".vbw-mu__pointB").addClass("winner");
        }
      }
    });
  }

  setStatusClass($el, matchData) {
    let _this = this;
    $el.removeClass("vbw-mu-scheduled");
    $el.removeClass("vbw-mu-live");
    $el.removeClass("vbw-mu-finished");

    $el.addClass(_this.statusClasses[matchData.status]);
    let $matchInfoBtn = $el.find(".vbw-mu__status-info-btn");
    let $matchDataBlock = $el.find(".vbw-mu__data");
    const isCarousel = $(".vbw-matches-carousel");

    if (typeof matchData.hasLineup !== "undefined" && matchData.hasLineup) {
      $el.attr("data-has-lineup", "true");
      $el.find(".vbw-match--btn").addClass("haslineup");

      if ($matchInfoBtn) {
        const matchUrl = $matchInfoBtn.data("matchurl");
        $matchInfoBtn.attr("href", matchUrl);
      }
      if ($matchDataBlock) {
        const matchUrl = $matchDataBlock.data("matchurl");
        $matchDataBlock.attr("href", matchUrl);
      }
    } else {
      $el.attr("data-has-lineup", "false");
      $el.find(".vbw-match--btn").removeClass("haslineup");

      $matchInfoBtn = $el.find(".vbw-mu__status-info-btn");
      $matchInfoBtn.attr("href", "");

      $matchDataBlock = $el.find(".vbw-mu__data");
      $matchDataBlock.attr("href", "");
    }

    if (
      matchData.liveStreamUrl &&
      matchData.status === _this.matchStatus.LIVE
    ) {
      if (isCarousel.length > 0) {
        let liveButton = $el.find(".vbw-live--btn");
        let statusLabel = $el.find(".vbw-mu__status");
        statusLabel.addClass("status-hidden");
        liveButton.addClass("active");
        liveButton.attr("href", matchData.liveStreamUrl);
      }
    } else if (matchData.status === _this.matchStatus.LIVE) {
      if (isCarousel.length > 0) {
        let liveButton = $el.find(".vbw-live--btn");
        let statusLabel = $el.find(".vbw-mu__status");
        statusLabel.removeClass("status-hidden");
        liveButton.removeClass("active");
      }
    }
  }

  updateStatus(matchData) {
    let _this = this;
    let $match = _this.$MatchList.filter(
      '[matchid="match-' + matchData.no + '"]',
    );
    _this.setStatusClass($match, matchData);
    let isBye = $match.find("[data-is-bye='true']");

    if (isBye.length > 0) {
      const byeText = isBye.attr("data-bye-text");
      $match.find(".vbw-mu__status .vbw-mu__status--detail").text(byeText);
    } else {
      $match
        .find(".vbw-mu__status .vbw-mu__status--detail")
        .text(
          translationHelperObj.getText(
            "matchstatus-" + matchData.statusLabel.toLowerCase(),
          ),
        );
    }
  }

  isMatchGoneLive(matchNo) {
    return (
      matchDataCollector?.isMatchPage() &&
      !matchDataCollector?.channelLoaded &&
      matchconfig?.match === matchNo &&
      matchDataCollector?.isMatchLive()
    );
  }

  init() {
    let _this = this;
    _this.$MatchList = $(".vbw-match-unit-list .vbw-mu--match.vbw-mu");
  }
}
